export default __webpack_public_path__ + "static/traffic-lead-6-af336a7389256c9ad9edaa91282b823e.jpg";